import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./ServiceRealizationFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import ServiceRealizationFormStepOne from "./Steps/ServiceRealizationFormStepOne";
import ServiceRealizationFormStepTwo from "./Steps/ServiceRealizationFormStepTwo";

const ServiceRealizationForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (!update) {
      setInitialValues({
        ..._initialValues,
        inspection: 0,
        repair: 0,
        implementation: 0,
        diagnostics: 0,
        itService: 0,
        distance: _initialValues?.finalCounter - _initialValues?.initialCounter,
      });
      return;
    }
    if (update) {
      setInitialValues({
        ..._initialValues,
        distance: _initialValues?.finalCounter - _initialValues?.initialCounter,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  if (!initialValues) return null;

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit({ ...val }, props)}
      validate={(val) => onValidate({ ...val }, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="ServiceRealizationForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <ServiceRealizationFormStepOne {...formProps} {...props} />
              <ServiceRealizationFormStepTwo {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default ServiceRealizationForm;
